import createVueApp from '@/common/createApp'

Styxie.Initializers.ProfileBilling = {
  subscriptions: async(props) => {
    const { default: Component } = await import('@/vue_widgets/profile/billing_subscriptions/index.vue')
    createVueApp(Component, { props })
  }
}
